
import React from "react";
import { CalendarDays, Camera, Download, TrendingUp } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import TocFotosProgressLine from "./TocFotosProgressLine";
import TocFotosCounter from "./TocFotosCounter";

const TocFotosSteps = () => {
  const steps = [
    {
      icon: <CalendarDays className="h-12 w-12 text-[#FF5605]" />,
      title: "Agende sua sessão",
      description: "Escolha o melhor dia e horário",
    },
    {
      icon: <Camera className="h-12 w-12 text-[#FF5605]" />,
      title: "Fotografia profissional",
      description: "Nossa equipe vai até o imóvel",
    },
    {
      icon: <Download className="h-12 w-12 text-[#FF5605]" />,
      title: "Baixe as fotos",
      description: "Em até 48 horas, com edições impecáveis",
    },
    {
      icon: <TrendingUp className="h-12 w-12 text-[#FF5605]" />,
      title: "Mais Cliques, Mais Vendas",
      description: "Use as imagens para atrair mais clientes",
    },
  ];

  return (
    <div className="container max-w-7xl mx-auto px-4 relative">
      <div className="my-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <TocFotosCounter end={500} suffix="+" title="Imóveis fotografados" />
        <TocFotosCounter end={200} suffix="+" title="Clientes satisfeitos" />
        <TocFotosCounter end={97} suffix="%" title="Índice de aprovação" />
      </div>
    
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-semibold text-[#261E13] mb-4">
          Como funciona
        </h2>
        <p className="text-lg md:text-xl text-[#261E13]/70 max-w-2xl mx-auto">
          Nosso processo é pensado para facilitar sua vida e valorizar seu imóvel
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
        <TocFotosProgressLine />
        
        {steps.map((step, index) => (
          <div key={index}>
            <Card 
              className="border-0 shadow-lg h-full bg-white rounded-lg overflow-hidden relative z-20"
            >
              <CardContent className="p-8 flex flex-col items-center text-center h-full">
                <div className="mb-6 p-4 bg-[#3332FC]/5 rounded-full">
                  {step.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3 text-[#261E13]">
                  {step.title}
                </h3>
                <p className="text-[#261E13]/70">
                  {step.description}
                </p>
                <div className="mt-4 text-2xl font-bold text-[#FF5605]">
                  {index + 1}
                </div>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TocFotosSteps;
